module.exports = __webpack_public_path__ + "img/img_21.3d15e32e.jpg";